<template>
  <div class="match-com">
    <div
      class=""
      v-if="headType == '1' && isName == 'pre_schedule' && !matchstate"
    >
      <div style="margin-bottom:20px" v-if="tabName == 'final'">
        <img
          width="100%"
          src="../../../assets/match_img/4_Website_Banner_boy_plate.jpg"
          alt=""
        />
      </div>
      <div style="margin-bottom:20px" v-if="tabName == 'silver'">
        <img
          width="100%"
          src="../../../assets/match_img/3_Website_Banner_boy_silver.jpg"
          alt=""
        />
      </div>
      <div style="margin-bottom:20px" v-if="tabName == 'gold'">
        <img
          width="100%"
          src="../../../assets/match_img/2_Website_Banner_boy_gold.jpg"
          alt=""
        />
      </div>
    </div>
    <div v-if="headType == '2' && isName == 'pre_schedule' && !matchstate">
      <div style="margin-bottom:20px" v-if="tabName == 'grand_finals'">
        <img
          width="100%"
          src="../../../assets/match_img/Website_Banner_girl_final.jpg"
          alt=""
        />
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <div class="match-tab" v-show="matchShow">
        <div class="tab">
          <div
            :class="[currentIndex === index ? 'current' : '', 'show-box']"
            :key="item.id"
            v-for="(item, index) in monthList"
          >
            <div class="select" :class="{ 'option-f': headType === '2' }">
              <!-- month selection -->
              <el-select
                :popper-append-to-body="false"
                :no-data-text="$t('home.nodata')"
                v-model="monthValue"
                :placeholder="$t('schedule.month_select')"
              >
                <el-option
                  v-for="item in monthList"
                  :key="item.mon"
                  :label="item.mon"
                  :value="item.mon"
                >
                  <p class="team-name" @click="change(index, item)">
                    {{ item.mon }}
                  </p>
                </el-option>
              </el-select>
              <!-- team selection -->
              <el-select
                :popper-append-to-body="false"
                :no-data-text="$t('home.nodata')"
                v-model="teamvalue"
                :placeholder="$t('schedule.select')"
              >
                <el-option
                  v-for="item in team"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <p class="team-name" @click="teamId(item.value)">
                    {{ item.label }}
                  </p>
                </el-option>
              </el-select>
            </div>
            <div v-if="roundList.length > 0">
              <div
                class="tab-content"
                v-for="(item, index) in roundList"
                :key="index"
              >
                <div class="play-box play-time">
                  <p>{{ item.day }}</p>
                  <p style="font-size: 19px; font-weight: 600">
                    {{ item.format_date }}
                  </p>
                  <p>{{ item.format_time }}</p>
                </div>
                <div class="play-box play-team1">
                  <p class="play-txt1">
                    <span class="sp2">{{ item.first_team_name }}</span>
                  </p>
                  <p class="play-txt2">
                    <img
                      width="60px"
                      height="60px"
                      :src="item.first_team.temp_icon_path_url"
                      alt=""
                    />
                  </p>
                  <p class="play-txt3" style="color: #2d3b51">
                    {{ item.first_team_grade }}
                  </p>
                </div>
                <div class="play-box play-tit">
                  <p>ROUND{{ item.schedule_round.round }}</p>
                  <p>{{ item.ground }}</p>
                </div>
                <div class="play-box play-team2">
                  <p class="play-txt3" style="color: #2d3b51">
                    {{ item.second_team_grade }}
                  </p>
                  <p class="play-txt2">
                    <img
                      width="60px"
                      height="60px"
                      :src="item.second_team.temp_icon_path_url"
                      alt=""
                    />
                  </p>
                  <p class="play-txt1" style="text-align: left">
                    <span class="sp2">{{ item.second_team_name }}</span>
                  </p>
                </div>
                <div class="play-box play-stats" @click="statspage(item.id)">
                  <p>
                    {{ $t("schedule.stats") }}
                    <i
                      class="el-icon-right"
                      :style="{ color: headType === '2' ? '#B9A2C9' : '' }"
                    ></i>
                  </p>
                </div>
              </div>
            </div>
            <div v-else>
              <p class="no-data">{{ $t("home.nodata") }}</p>
            </div>
            <div
              class="paginationStyle"
              :class="headType == 1 ? 'boy' : 'girl'"
            >
              <el-pagination
                background
                @current-change="handleCurrentChange"
                :page-size="pageSize"
                layout="prev, pager, next"
                :total="total"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-fade-in-linear">
      <MatchStats
        v-loading="matchLoding"
        :matchData="matchData"
        @returnpage="returnpage"
        v-show="matchstate"
      />
    </transition>
  </div>
</template>

<script>
import { BasketballApi } from "../../../api/basketball.js";
import { mapState } from "vuex";
import MatchStats from "./MatchStats.vue";

export default {
  props: [
    "latestLists",
    "monthList",
    "tabid",
    "roundList",
    "girltabid",
    "team",
    "currentIndex",
    "tabName",
    "isName",
    "total",
    "handleCurrentChange"
  ],
  components: {
    MatchStats
  },
  data() {
    return {
      monthValue: "",
      teamvalue: "",
      selectValue: "",
      matchLoding: false,
      monthnum: "",
      matchId: "",
      matchShow: true,
      matchstate: false,
      showcom: "Schedule1",
      matchData: "",
      pageSize: 20
    };
  },
  computed: {
    ...mapState(["headType"])
  },
  watch: {
    headType(value) {
      // this.$router.go(0)
      this.montabId = "";
      if (value == "1") {
        this.tabid = "2";
        this.activeNameBoys = "0";
      } else {
        this.girltabid = "10";
        this.activeNameGirls = "0";
      }
      // this.getScheduleRoundsList();
      // this.getMonth()
      this.monthtab();
    }
  },
  methods: {
    teamId(val) {
      this.$emit("teamId", val);
    },
    change(index, item) {
      this.monthnum = item.num;
      this.monthValue = item.mon;
      this.$emit("monthtab", item.num, index);
    },
    returnpage() {
      this.matchShow = true;
      this.matchstate = false;
    },
    statspage(id) {
      this.$router.push(`match_schedule&game_stats&statid/${id}`);
      this.matchId = id;
      this.getCompetitionDeatils();
      // this.matchShow = false;
      // this.matchstate = true;
    },
    //获取赛程详情
    getCompetitionDeatils() {
      this.matchLoding = true;
      BasketballApi.getCompetitionDeatils(this.matchId).then(res => {
        this.matchData = res;
        this.matchData.first_team_member_total.team_name = this.matchData.first_team_name;
        this.matchData.second_team_member_total.team_name = this.matchData.second_team_name;
        const team_data_total = [];
        team_data_total.push(this.matchData.first_team_member_total);
        team_data_total.push(this.matchData.second_team_member_total);
        this.matchData.team_data_total = team_data_total;
        // this.matchData.first_team_data.first_team_name
        this.matchLoding = false;
      });
    }
  }
};
</script>

<style lang="scss">
.match-com {
  .paginationStyle {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 20px 0 50px 0;
  }

  .boy {
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #318bc8; // 进行修改选中项背景和字体
      color: #fff;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #318bc8;
    }
  }

  .girl {
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: rgb(185, 162, 201); // 进行修改选中项背景和字体
      color: #fff;
    }
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: rgb(185, 162, 201);
    }
  }

  .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #fff; // 进行修改未选中背景和字体
    // color: #fff;
  }

  .select {
    height: 130px;
    border-bottom: 2px solid #eff1f7;
    .el-select {
      margin: 40px 50px 0 0;
      width: 203px;
      border: none;
      float: right;
      .el-input {
        .el-select__caret {
          color: #318bc8;
        }
        .el-input__inner {
          height: 47px;
          border: 1px solid #318bc8;
          border-radius: 15px;
          color: #318bc8 !important;
        }
      }
      .el-select-dropdown__item.selected {
        color: #318bc8;
      }
      .team-name {
        text-align: left;
      }

      @media screen and (max-width: 510px) {
        margin: 10px 10px 0 0;
      }
    }
  }
  .option-f {
    .el-select {
      .el-input {
        .el-select__caret {
          color: #b9a2c9;
        }
        .el-input__inner {
          border: 1px solid #b9a2c9;
          border-radius: 14.5px;
          color: #b9a2c9 !important;
        }
      }
      .el-select-dropdown__item.selected {
        color: #b9a2c9;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.match-com {
  .match-tit {
    background: #318bc8;
    line-height: 60px;
    text-align: left;
    padding-left: 35px;
    color: #fff;
    font-size: 20px;
    // border: 2px solid #fff;
    border-top: none;
  }
  .match-tab {
    .tab .month-box {
      overflow: hidden;
      margin-bottom: 2px;
      display: flex;
      margin-top: 15px;
      border-bottom: 2px solid rgb(238, 236, 236);
      justify-content: space-around;
    }
    .tab .month-box .month {
      list-style: none;
      text-align: center;
      cursor: pointer;
      font-size: 17px;
      color: #8d929b;
      padding: 0 10px;
    }
    .tab .month-box .month.active {
      // background-color: orange;
      color: #2d3b51;
      font-weight: 600;
      border-bottom: 3px solid #2d3b51;
    }
    .tab {
      .show-box {
        width: 100%;
        height: 100%;
        text-align: center;
        display: none;
        .tab-content:hover {
          background: #eff5fa;
        }
        .tab-content {
          display: flex;
          justify-content: space-around;
          border-bottom: 2px solid #c5cfe348;
          // margin-top: 30px;
          .play-box {
            width: 20%;
            height: 100px;
            margin: 10px;
            padding-top: 10px;
          }
          .play-time,
          .play-tit,
          .play-stats {
            line-height: 25px;
            width: 17%;
            color: #2d3b51;
          }
          .play-stats {
            width: 8%;
          }
          .play-team1,
          .play-team2 {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
            // padding-top: 30px;
            .play-txt1 {
              width: 33.3%;
              text-align: right;

              // padding: 10px;
              .sp1 {
                color: #5aa2d3;
              }
              .sp2 {
                font-size: 18px;
                font-weight: 600;
                color: #2d3b51;
              }
            }
            .play-txt2 {
              width: 33.3%;
              margin: 0 20px;
              margin-top: -10px;
              img {
                border-radius: 10px;
              }
            }
            .play-txt3 {
              width: 33.3%;
              font-size: 30px;
              font-weight: 600;
              color: #c2cfe5;
            }
          }
        }

        .play-stats {
          p {
            margin-top: 30px;
            cursor: pointer;
          }
          i {
            color: #5aa2d3;
          }
          :hover {
            color: #888888;
          }
        }
      }
    }

    .tab .show-box.current {
      display: block;
    }
  }
  .no-data {
    height: 300px;
    line-height: 300px;
    font-size: 40px;
    color: #cccfd1;
  }
}
@media screen and (max-width: 768px) {
  .tab {
    overflow-x: scroll;
    .tab-content {
      flex-direction: column;
      .play-box {
        line-height: 25px;
        width: 90% !important;
        margin-left: 5% !important;
        height: auto !important;
      }
      .play-time {
        order: 1;
        display: flex;
        justify-content: space-between;
      }
      .play-tit {
        order: 2;
        // display: flex;
        // justify-content: space-between;
        // font-weight: 600;
      }
      .play-team1 {
        order: 3;
        .play-txt1 {
          text-align: left !important;
        }
      }
      .play-team2 {
        order: 4;
        .play-txt3 {
          order: 3;
        }
        .play-txt2 {
          order: 2;
        }
        .play-txt1 {
          order: 1;
          text-align: left;
        }
      }
      .play-stats {
        order: 5;
      }
    }
    .tab-content:nth-child(2n-1) {
      background: rgba(217, 230, 243, 0.363) !important;
    }
  }
}
</style>
